import { render, staticRenderFns } from "./TestContinentForm.vue?vue&type=template&id=35036ee8"
import script from "./TestContinentForm.vue?vue&type=script&lang=js"
export * from "./TestContinentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35036ee8')) {
      api.createRecord('35036ee8', component.options)
    } else {
      api.reload('35036ee8', component.options)
    }
    module.hot.accept("./TestContinentForm.vue?vue&type=template&id=35036ee8", function () {
      api.rerender('35036ee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/grid/TestContinentForm.vue"
export default component.exports